import React from 'react'
import { Menu } from 'antd'

const row = ({ index, handleDelete }) => (<Menu>
  <Menu.Item onClick={() => handleDelete(index)}>
    <button type="button" className="btn btn-link btn-sm text-dark">Delete</button>
  </Menu.Item>
</Menu>)

export default row